module.exports = __webpack_public_path__ + "img/calculadora.772450b4.svg";